import { ChartType } from '@principle-theorem/reporting/interfaces';
import { BaseChart } from './base-chart';
import { ChartOptions, type IChartData } from './chart-builder';

export class LineChart extends BaseChart {
  data: IChartData = {
    type: ChartType.Line,
    options: ChartOptions.init({
      legend: { position: 'none' },
    }),
  };
}
